import { Card, Clickable } from '@warp-ds/react';
import styles from './PopularDestinationsCard.module.css';

type PopularDestinationsCardProps = {
    src: string;
    alt: string;
    label: string;
    href: string;
};

export const PopularDestinationsCard = ({ src, alt, label, href }: PopularDestinationsCardProps) => (
    <Card className={`rounded-16 h-full relative ${styles.aspectContainer}`}>
        <img src={src} loading="lazy" alt={alt} className="absolute inset-0 w-full h-full object-cover z-0" />
        <div className={`absolute inset-0 z-0 ${styles.overlay}`} />
        <Clickable
            href={href}
            className="relative flex items-end h-full pt-32 px-12 pb-12 font-bold s-text-inverted text-16 hover:no-underline">
            {label}
        </Clickable>
    </Card>
);
